module.exports = __webpack_public_path__ + "static/media/8900_Bedroom3.54536f7d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/GalleryPhotos/8900_Bedroom3.jpg
// module id = 572
// module chunks = 0